// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-bottom-primary {\n  border-bottom: 1px solid hsl(210, 86%, 57%);\n}\n.template-items-modal,\n.modal-card {\n  min-width: 800px;\n  width: 60vw;\n}\n.template-items-container {\n  overflow-y: auto;\n  max-height: 50vh;\n}\n.template-item-grid.is-title {\n  position: sticky;\n  top: -1px;\n  border-bottom: 1px;\n  z-index: 3;\n  border-top: 1px solid rgba(136, 136, 136, 0.3);\n  border-bottom: 1px solid rgba(136, 136, 136, 0.3);\n}", ""]);
// Exports
module.exports = exports;
